export async function syncToGoogleCalendar({commit}, payload) {
  commit('showPageLoading', payload, {root: true});
  const response = await this.$frontendRepositories.calendar.sync();
  const {errResponse, data: responseData} = response;
  commit('hidePageLoading', payload, {root: true});
  if (!errResponse && responseData.success) {
    await commit('frontend/auth/setCalendar', responseData.data.url, {root: true});
  }

  return response;
}

export async function unSyncWithGoogleCalendar({commit}, payload) {
  commit('showPageLoading', payload, {root: true});
  const response = await this.$frontendRepositories.calendar.unSync();
  commit('hidePageLoading', payload, {root: true});

  return response;
}

export async function getAllProposalInRange({commit}, {start, end, from}) {
  commit('setCalendarList', [])

  const {errResponse, data: responseData} = await this.$frontendRepositories.calendar.get(start, end);
  if (!errResponse && responseData.success) {
    commit('setCalendarList', responseData.data)

    switch (from) {
      case 'dashboard':
        commit('frontend/proposals/setProposalsDeadlineInMonth', responseData.data, {root: true})
        break;
      default:
        break;
    }
  }

  this.$busEmit('proposal-dashboard');
}

export async function callBackGoogle({commit}, payload) {
  commit('showPageLoading', payload, {root: true});
  const response = await this.$frontendRepositories.calendar.callback(payload);
  commit('hidePageLoading', payload, {root: true});
  return response;
}

export function changeNeedShowProposalModal({commit}, flag) {
  localStorage.needShowProposalModal = flag
  commit('setNeedShowProposalModal', flag)
}

export function syncNeedShowProposalModal({commit}) {
  commit('setNeedShowProposalModal', localStorage.needShowProposalModal == 'true' ? true : false)
}

export async function saveDashboardModal({commit}, payload) {
  const response = await this.$frontendRepositories.proposals.saveDashboardModal(payload);
  return response
}

export async function updateTodoDeadline({commit, state}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.proposals.updateTodoDeadline(payload);
  commit('setBtnLoading', false, {root: true});

  return response
}

export async function showConfirmDragged({commit}, payload) {
  commit('setShowCalendarDragModal', true)
  commit('setDragCalendarState', payload)
}

export async function resetConfirmDragged({commit}) {
  commit('setShowCalendarDragModal', false)
  commit('setDragCalendarState', {
    draggedEvent: {},
    divSecond: 0,
    error: ''
  })
}

export async function cloneCalendarTodo({commit, state}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.proposals.cloneCalendarTodo(payload);
  commit('setBtnLoading', false, {root: true});

  return response
}

export async function fetchProcessingTodo({state}, payload) {
  const response = await this.$frontendRepositories.proposals.fetchProcessingTodo(payload);
  return response
}

export async function updateProcessingEvents({state, commit}, proposals) {
  let mstProposalIds = proposals.map(item => item.mst_proposal_id)

  let currentProposalIds = state.calendarList.map(item => item.id)
  
  commit('concatCalendarList', proposals.filter(item => !currentProposalIds.includes(item.id)))
  commit('removeMstProcessingEventById', mstProposalIds)
}
